// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.lancer-marche-modal {
  background-color: #FFFDFC;
  border-radius: 10px;
  padding: 2rem;
  width: 90%;
  max-width: 500px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.lancer-marche-modal h2 {
  color: #2C3948;
  font-size: 2rem;
  margin-bottom: 1.5rem;
  text-align: center;
}

.lancer-marche-modal .form-group {
  margin-bottom: 1.5rem;
}

.lancer-marche-modal label {
  display: block;
  font-size: 1.4rem;
  font-weight: 600;
  margin-bottom: 0.5rem;
  color: #2C3948;
}

.lancer-marche-modal input,
.lancer-marche-modal select {
  width: 100%;
  padding: 1rem;
  border: 1px solid #E5E7EB;
  border-radius: 8px;
  font-size: 1.4rem;
}

.lancer-marche-modal input:focus,
.lancer-marche-modal select:focus {
  outline: none;
  border-color: #DA7027;
}

.lancer-marche-modal .error {
  border-color: #EF4444;
}

.lancer-marche-modal .error-message {
  color: #EF4444;
  font-size: 1.2rem;
  margin-top: 0.5rem;
  display: block;
}

.lancer-marche-modal .required {
  color: #EF4444;
}

.lancer-marche-modal .modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
  margin-top: 2rem;
}

/* Animation d'entrée */
.lancer-marche-modal {
  animation: slideIn 0.3s ease-out;
}

@keyframes slideIn {
  from {
    transform: translateY(-30px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}`, "",{"version":3,"sources":["webpack://./src/composants/LancerMarcheModal/LancerMarcheModal.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,UAAU;EACV,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA;EACE,cAAc;EACd,eAAe;EACf,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;;EAEE,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;;EAEE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,gBAAgB;AAClB;;AAEA,uBAAuB;AACvB;EACE,gCAAgC;AAClC;;AAEA;EACE;IACE,4BAA4B;IAC5B,UAAU;EACZ;EACA;IACE,wBAAwB;IACxB,UAAU;EACZ;AACF","sourcesContent":[".modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n}\n\n.lancer-marche-modal {\n  background-color: #FFFDFC;\n  border-radius: 10px;\n  padding: 2rem;\n  width: 90%;\n  max-width: 500px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n}\n\n.lancer-marche-modal h2 {\n  color: #2C3948;\n  font-size: 2rem;\n  margin-bottom: 1.5rem;\n  text-align: center;\n}\n\n.lancer-marche-modal .form-group {\n  margin-bottom: 1.5rem;\n}\n\n.lancer-marche-modal label {\n  display: block;\n  font-size: 1.4rem;\n  font-weight: 600;\n  margin-bottom: 0.5rem;\n  color: #2C3948;\n}\n\n.lancer-marche-modal input,\n.lancer-marche-modal select {\n  width: 100%;\n  padding: 1rem;\n  border: 1px solid #E5E7EB;\n  border-radius: 8px;\n  font-size: 1.4rem;\n}\n\n.lancer-marche-modal input:focus,\n.lancer-marche-modal select:focus {\n  outline: none;\n  border-color: #DA7027;\n}\n\n.lancer-marche-modal .error {\n  border-color: #EF4444;\n}\n\n.lancer-marche-modal .error-message {\n  color: #EF4444;\n  font-size: 1.2rem;\n  margin-top: 0.5rem;\n  display: block;\n}\n\n.lancer-marche-modal .required {\n  color: #EF4444;\n}\n\n.lancer-marche-modal .modal-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 1rem;\n  margin-top: 2rem;\n}\n\n/* Animation d'entrée */\n.lancer-marche-modal {\n  animation: slideIn 0.3s ease-out;\n}\n\n@keyframes slideIn {\n  from {\n    transform: translateY(-30px);\n    opacity: 0;\n  }\n  to {\n    transform: translateY(0);\n    opacity: 1;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
